import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../service/auth.service';

@Injectable()
export class AlwaysAuthGuard implements CanActivate {

    constructor(private router: Router, private authService: AuthService) {
    }

    canActivate(route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot) {
        if (this.authService.isLoggedIn()) {
            // User is signed in
            return true;
        } else {
            // no user is signed in
            console.log('User is not signed in, redirecting to log in form');
            console.log('With route params', state.url);
            this.router.navigate(['/pages/login'], { queryParams: { returnUrl: state.url }});
            return false;
        }
    }
  }



// WEBPACK FOOTER //
// /Users/pkovacs/Documents/Development/ngsAlpha/ngs_alpha_ui/src/app/guards/alwaysauth.guard.ts